/**
 * Shared Tailwind class string used as the OUTER bordered box for every form-field
 * primitive — `Input`, `SelectTrigger` (size="md"), `DatePicker`.
 *
 * Keep this as the single source of truth so rows like `Основание / Номер`,
 * `Контрагент / Тип арендатора`, `Срок действия: date — date` render pixel-identical
 * regardless of whether the underlying element is `<div>`, `<input>`, or Radix `<button>`.
 *
 * Consumers add their own layout class (`flex-1`, `w-full`, etc.) via `className` — that
 * gets merged in via `cn(formFieldBoxClass, className)` at callsite.
 */
export const formFieldBoxClass =
	'flex h-[42px] w-full items-center gap-2 rounded-(--radius-md) border border-(--color-input) bg-(--color-background) px-4 py-2.5 text-sm leading-5 font-normal text-(--color-foreground) transition-colors ' +
	'focus-within:border-(--color-focus) focus-within:ring-2 focus-within:ring-(--color-ring) ' +
	'disabled:cursor-not-allowed disabled:opacity-60 disabled:bg-(--color-muted)'
